import React, { ErrorInfo, useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Monitor } from '../../../../platform/Monitor';
import { Flexer } from '../../../dashboard/elements/LayoutElements';
import { AutoLayoutAdapter } from '../../../packages/autoLayout/AutoLayoutAdapter';
import { JukeboxAdapter } from '../../../packages/jukebox/JukeboxAdapter';
import { AdapterInfo } from '../../AdapterInfo';
import { useEditorSessionObserver } from '../../EditorSession';
import { FieldAdapter } from './FieldAdapter';

export const AdapterLayer = () => {

    const ai = useEditorSessionObserver(AdapterInfo);

    const onError = useCallback((error: Error, info: ErrorInfo) => {
        Monitor.error(`RenderError in Adapter: ${ai?.name}`, error, info);
    }, [ai]);

    if (ai.target === 'none') return null;

    return <Flexer id="adapter-layer" absolute inset pointerEvents="none">
        <ErrorBoundary {...{ onError }} fallback={<div />} >
            {ai.type === 'autoLayout' && <AutoLayoutAdapter info={ai} />}
            {ai.type === 'field' && <FieldAdapter info={ai} />}
            {ai.type === 'jukebox' && <JukeboxAdapter info={ai} />}
        </ErrorBoundary>
    </Flexer>;
};
